


























































import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import Component from 'vue-class-component'
import {Prop, Watch} from "vue-property-decorator";
import {Action} from "vuex-class";

@Component({})
export default class StatusesHistoryTableComponent extends AfterFetchComponent {
  @Prop(Number) memberProcessId: any;
  @Prop(Boolean) updateStatusesTable: any;

  @Action('getChangesHistories', StoreNamespace.PROCESSES) getChangesHistories: any

  private changesHistories: any = [];

  mounted() {
    if (this.memberProcessId) {
      this.getChangesHistories({
        requestorCallback: this,
        pathVariable: this.memberProcessId
      });
    }
  }

  @Watch('memberProcessId')
  onMemberProcessIdChanged() {

    if (this.memberProcessId && this.memberProcessId > 0) {
      this.getChangesHistories({
        requestorCallback: this,
        pathVariable: this.memberProcessId
      });
    }
  }

  @Watch('updateStatusesTable')
  onUpdateStatusesTable() {

    if (this.memberProcessId && this.memberProcessId > 0) {
      this.getChangesHistories({
        requestorCallback: this,
        pathVariable: this.memberProcessId
      });
    }
  }


  private getStatusClass(status: string) {
    switch (status) {
      case 'הבקשה הוגשה':
        return 'request-submit';
      case 'הבקשה בהשהיה' :
        return 'under_examination';
      case 'מאשר שני – מנהל':
      case 'מאשר ראשון – עובד':
        return 'first_approve';
      case 'הבקשה נדחתה':
        return 'rejected'
    }

    return '';
  }

  onSuccess<T>(data?: T, requestName?: string, message?: string) {
    switch (requestName) {
      case 'getChangesHistories':
        this.changesHistories = data;
    }
  }
}
